/*
 * @Author: chengyu
 * @Date: 2022-10-13 19:51:52
 * @Description: 描述
 */
/**
 * 逆地理编码埋点状态
 *
 * - 1:请求高德成功；
 * - 2:降级到自研后，自研成功；
 * - 3:降级到自研后，自研失败
 */
export var MapRgcStatusEnum;
(function (MapRgcStatusEnum) {
    /**
     * 高德成功
     */
    MapRgcStatusEnum[MapRgcStatusEnum["gaodeSuccess"] = 1] = "gaodeSuccess";
    /**
     * 自研成功
     */
    MapRgcStatusEnum[MapRgcStatusEnum["lbsSuccess"] = 2] = "lbsSuccess";
    /**
     * 自研失败
     */
    MapRgcStatusEnum[MapRgcStatusEnum["lbsError"] = 3] = "lbsError";
    /**
     * 高精度
     */
    MapRgcStatusEnum[MapRgcStatusEnum["high"] = 10] = "high";
    /**
     * 粗精度
     */
    MapRgcStatusEnum[MapRgcStatusEnum["low"] = 11] = "low";
    /**
     * 未命中
     */
    MapRgcStatusEnum[MapRgcStatusEnum["unknown"] = -1] = "unknown";
})(MapRgcStatusEnum || (MapRgcStatusEnum = {}));
export var MapApiEnum;
(function (MapApiEnum) {
    /**
     * 高德成功
     */
    MapApiEnum[MapApiEnum["gaodeSuccess"] = 1] = "gaodeSuccess";
    /**
     * 高德失败
     */
    MapApiEnum[MapApiEnum["gaodeError"] = 2] = "gaodeError";
    /**
     * 自研成功
     */
    MapApiEnum[MapApiEnum["lbsSuccess"] = 3] = "lbsSuccess";
    /**
     * 自研失败
     */
    MapApiEnum[MapApiEnum["lbsError"] = 4] = "lbsError";
    /**
     * 请求缓存
     */
    MapApiEnum[MapApiEnum["httpCache"] = 5] = "httpCache";
    /**
     * 结果缓存
     */
    MapApiEnum[MapApiEnum["resultCache"] = 6] = "resultCache";
    /**
     * 未知状态
     */
    MapApiEnum[MapApiEnum["unknown"] = -1] = "unknown";
})(MapApiEnum || (MapApiEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidWJ0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvcmUvZW51bXMvdWJ0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFFSDs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQU4sSUFBWSxnQkF5Qlg7QUF6QkQsV0FBWSxnQkFBZ0I7SUFDMUI7O09BRUc7SUFDSCx1RUFBZ0IsQ0FBQTtJQUNoQjs7T0FFRztJQUNILG1FQUFjLENBQUE7SUFDZDs7T0FFRztJQUNILCtEQUFZLENBQUE7SUFDWjs7T0FFRztJQUNILHdEQUFTLENBQUE7SUFDVDs7T0FFRztJQUNILHNEQUFRLENBQUE7SUFDUjs7T0FFRztJQUNILDhEQUFZLENBQUE7QUFDZCxDQUFDLEVBekJXLGdCQUFnQixLQUFoQixnQkFBZ0IsUUF5QjNCO0FBRUQsTUFBTSxDQUFOLElBQVksVUE2Qlg7QUE3QkQsV0FBWSxVQUFVO0lBQ3BCOztPQUVHO0lBQ0gsMkRBQWdCLENBQUE7SUFDaEI7O09BRUc7SUFDSCx1REFBYyxDQUFBO0lBQ2Q7O09BRUc7SUFDSCx1REFBYyxDQUFBO0lBQ2Q7O09BRUc7SUFDSCxtREFBWSxDQUFBO0lBQ1o7O09BRUc7SUFDSCxxREFBYSxDQUFBO0lBQ2I7O09BRUc7SUFDSCx5REFBZSxDQUFBO0lBQ2Y7O09BRUc7SUFDSCxrREFBWSxDQUFBO0FBQ2QsQ0FBQyxFQTdCVyxVQUFVLEtBQVYsVUFBVSxRQTZCckIifQ==